import React from 'react'
import { useSharedStyles } from '../../Settings/useSharedStyles'
import { Box, Typography } from '@mui/material'

import { useTranslation } from 'react-i18next'
import { Info } from '@mui/icons-material'
import { DataCheckbox } from '@/components/settings/components/DataCheckbox'
import { RawLink } from '@/shared/ui/RawLink'
import { OpenLink } from '@/shared/ui/Icons'

const AgreementsSection = () => {
    const { t: translate } = useTranslation()
    const {
        titleStyle,
        titleContainer,
        sectionStyle,
        iconContainer,
        dataContainer,
    } = useSharedStyles()
    return (
        <Box sx={sectionStyle}>
            <Box sx={titleContainer}>
                <Box sx={iconContainer}>
                    <Box ml="-2px" mt="-2px">
                        <Info />
                    </Box>
                </Box>
                <Typography ml="24px" sx={titleStyle}>
                    {translate('agreements')}
                </Typography>
            </Box>
            <Box sx={dataContainer}>
                <Box display="flex">
                    <DataCheckbox
                        fieldName="TermsAndConditions"
                        value={true}
                        onChange={() => null}
                    />
                    <RawLink to="/termsAndConditions">
                        <Box mt="8px">
                            <OpenLink />
                        </Box>
                    </RawLink>
                </Box>
                <Box display="flex">
                    <DataCheckbox
                        fieldName="AcceptPrivacyPolicy"
                        value={true}
                        onChange={() => null}
                    />
                    <RawLink to="/termsAndConditions">
                        <Box mt="8px">
                            <OpenLink />
                        </Box>
                    </RawLink>
                </Box>
                <DataCheckbox
                    fieldName="ConsentMarketing"
                    value={true}
                    onChange={() => null}
                />
            </Box>
        </Box>
    )
}

export default AgreementsSection
